export { default } from './AirBnBFeaturedDestinationsContainerMobile';
